import * as zod from 'zod';

import {
  IntrinsicsCalibrationData,
  ExtrinsicsCalibrationData,
} from '@sb/integrations/types/cameraTypes';
import type { StreamInfo } from '@sb/messenger/auto_generated/messenger/camera_bot_service';
import {
  type CameraConfiguration as CameraConfigurationProtoType,
  type StereoConfiguration,
} from '@sb/messenger/auto_generated/messenger/camera_bot_service';

export const CameraConfiguration = zod.object({
  kind: zod.literal(`Camera`),
  name: zod.string().default(`Camera`),
  id: zod.string().default(''),
  configuration: zod
    .custom<CameraConfigurationProtoType>()
    .default({ configOptions: {} }),
  enableStereo: zod.boolean().default(false),
  stereoConfig: zod.custom<StereoConfiguration>().optional(),
  availableStreams: zod.array(zod.custom<StreamInfo>()).default([]),
  intrinsicsId: zod.string().nullable().default(null),
  extrinsicsId: zod.string().nullable().default(null),
  intrinsicsData: IntrinsicsCalibrationData.default({}),
  extrinsicsData: ExtrinsicsCalibrationData.default({}),
  showExtrinsicsInVisualizer: zod.boolean().default(true),
});

export type CameraConfiguration = zod.infer<typeof CameraConfiguration>;
